"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsSettingsContent = exports.getStateForAllSections = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const lodash_es_1 = require("lodash-es");
const getAvailableNotificationPreferences_1 = require("../../../features/NotificationsSettings/api/getAvailableNotificationPreferences");
const getNotificationPreferences_1 = require("../../../features/NotificationsSettings/api/getNotificationPreferences");
const upsertUserNotificationPreferences_1 = require("../../../features/NotificationsSettings/api/upsertUserNotificationPreferences");
const NotificationPreferenceTabs_1 = require("../../../features/NotificationsSettings/components/NotificationPreferenceTabs");
const types_1 = require("../../../features/NotificationsSettings/types");
const getStateForSection = (data, userPreferences) => {
    return data.preferences.reduce((acc, preference) => {
        (0, types_1.getReferences)(preference).forEach((reference) => {
            acc[reference] = {
                web: !!preference.default?.[notification_center_models_1.NotificationPreferenceOptionsEnum.web] || false,
                digestEmail: !!preference.default?.[notification_center_models_1.NotificationPreferenceOptionsEnum.digestEmail] || false,
                instantEmail: !!preference.default?.[notification_center_models_1.NotificationPreferenceOptionsEnum.instantEmail] || false,
                ...(userPreferences?.[reference] || {}),
            };
        });
        return acc;
    }, {});
};
const getStateForAllSections = (data, userPreferences) => {
    const overallStates = data.sections.map((sectionData) => getStateForSection(sectionData, userPreferences));
    return overallStates.reduce((acc, state) => ({ ...acc, ...state }), {});
};
exports.getStateForAllSections = getStateForAllSections;
const NotificationsSettingsContent = () => {
    const { data: availableShipmentNotificationPreferences = { sections: [] }, isFetching: isAvailableFetching } = (0, getAvailableNotificationPreferences_1.useAvailableNotificationPreferences)();
    const upsert = (0, upsertUserNotificationPreferences_1.useUpsertUserNotificationPreferences)();
    const { data, status, isFetching } = (0, getNotificationPreferences_1.useNotificationPreferences)();
    const updatePreferences = (preferences) => {
        upsert.mutate({ preferences });
    };
    const isError = (response) => {
        return !!response?.error || !!response?.message;
    };
    if (isAvailableFetching || isFetching) {
        return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", height: "100%", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CircularProgress, {}) }));
    }
    const userStateMap = isError(data)
        ? {}
        : data?.preferences?.reduce((acc, preference) => {
            acc[preference.reference] = (0, lodash_es_1.omit)(preference, 'reference');
            return acc;
        }, {});
    const shipmentPreferencesStateWithDefaults = (0, exports.getStateForAllSections)(availableShipmentNotificationPreferences, userStateMap);
    return ((0, jsx_runtime_1.jsx)(NotificationPreferenceTabs_1.NotificationPreferenceTabs, { availableNotificationPreferences: availableShipmentNotificationPreferences, state: shipmentPreferencesStateWithDefaults, updatePreferences: updatePreferences, status: status }));
};
exports.NotificationsSettingsContent = NotificationsSettingsContent;
//# sourceMappingURL=NotificationSettingsContent.js.map